export enum VerifyEmailSteps {
  Home = 'Home',
  InstitutionEmail = 'InstitutionEmail',
  FirstTryEmailSuccess = 'FirstTryEmailSuccess',
  SecondEmail = 'SecondEmail',
  SecondTryEmailSuccess = 'SecondTryEmailSuccess',
  StartChat = 'StartChat',
}
